module.exports = __webpack_public_path__ + "assets/img/star-3.454c354a.svg";